import { Navigate } from 'react-router-dom'
import { Text } from '@mantine/core'
import { useShell } from '../AppShell'
import { lastDashboard } from '../lib/lastDashboard'

/**
 * The front door.
 *
 * A dashboard, not a list of them. The app IS the dashboard — that is the whole
 * shape of it — so landing somebody on an index of their own dashboards puts a
 * page they have already read between them and their race.
 *
 * The dashboard list is still there, reached from the shell, for the times when
 * picking between them is actually the job.
 */
export default function HomeRedirect() {
  const { orgs } = useShell()
  const last = lastDashboard()
  if (last) return <Navigate to={`/d/${last}`} replace />

  // Nothing to go back to: a new account, a new browser, or a dashboard that
  // has since been deleted. The organisation's list is where a dashboard gets
  // made, so that is the right second choice.
  const first = orgs[0]
  if (!first) {
    return <Text c="dimmed">You aren't a member of any organisation yet.</Text>
  }
  return <Navigate to={`/o/${first.id}`} replace />
}
